import { Link } from 'react-router-dom';

const guides = [
  {
    icon: 'ri-tools-line',
    title: 'Como Soldar Geomembrana PEAD',
    description: 'Guia passo a passo para soldagem correta de geomembrana PEAD com cunha quente, incluindo preparação, temperatura e teste de qualidade.',
    to: '/como-soldar-geomembrana',
  },
  {
    icon: 'ri-table-line',
    title: 'Cunha Quente vs Extrusão',
    description: 'Entenda as diferenças entre os dois métodos de soldagem, suas vantagens, limitações e aplicações ideais.',
    to: '/cunha-quente-geomembrana',
  },
  {
    icon: 'ri-file-list-3-line',
    title: 'Normas de Soldagem no Brasil',
    description: 'Conheça as normas técnicas brasileiras NBR 16199 e NBR 15352 para soldagem de geomembrana.',
    to: '/soldagem-de-geomembrana',
  },
];

export default function GuidesSection() {
  return (
    <section className="py-16 md:py-24 bg-background-100">
      <div className="w-full px-4 md:px-6 lg:px-10">
        <div className="mb-10 md:mb-14">
          <span className="text-primary-500 text-xs uppercase tracking-widest mb-2 block">Conteúdo Técnico</span>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 uppercase leading-tight">Guias e Especificações</h2>
          <p className="text-foreground-500 text-sm mt-3 max-w-lg">Informação técnica detalhada sobre soldagem de geomembrana e critérios de seleção de equipamentos.</p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {guides.map((guide) => (
            <Link
              key={guide.to}
              to={guide.to}
              className="group bg-white rounded-2xl border border-background-200/70 p-6 md:p-8 hover:border-primary-300 transition-all duration-300 cursor-pointer"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-primary-100 mb-5 group-hover:bg-primary-200 transition-colors">
                <i className={`${guide.icon} text-primary-600 text-xl`} />
              </div>
              <h3 className="font-heading text-lg font-bold text-foreground-950 uppercase mb-3">{guide.title}</h3>
              <p className="text-foreground-500 text-sm leading-relaxed mb-5">{guide.description}</p>
              <span className="inline-flex items-center gap-1 text-primary-600 text-sm font-bold uppercase tracking-wide group-hover:text-primary-700">
                Ler guia <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform" />
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}